import { render, staticRenderFns } from "./MerchantAgents.vue?vue&type=template&id=2b135a15&scoped=true"
import script from "./MerchantAgents.vue?vue&type=script&lang=js"
export * from "./MerchantAgents.vue?vue&type=script&lang=js"
import style0 from "./MerchantAgents.vue?vue&type=style&index=0&id=2b135a15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b135a15",
  null
  
)

export default component.exports